// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6013510c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/comps/c3_tools/05_editor.vue
// module id = di/s
// module chunks = 1